/**
 * Меню поставщика — куда можно уйти с имени поставщика из любого экрана
 * (разметка владельца 25.09.26). Спека: `docs/specs/2026-09-25-supplier-card-design.md`.
 *
 * Товары — через `productsHref`, а не строкой: у «Товаров» свой разбор адреса.
 */
import { productsHref } from "@/lib/similar";

export type SupplierMenuItem = { key: string; label: string; href: string };

export function supplierCardHref(id: number): string {
  return `/supplier/${id}`;
}

/** Пункты меню по правам; «Карточку» можно выключить — на самой карточке она лишняя. */
export function supplierMenuItems(
  id: number,
  can: { orders: boolean; payments: boolean },
  withCard = true,
): SupplierMenuItem[] {
  const items: SupplierMenuItem[] = [];
  if (withCard) items.push({ key: "card", label: "Карточка поставщика", href: supplierCardHref(id) });
  items.push({ key: "products", label: "Все товары", href: productsHref(id) });
  items.push({ key: "plans", label: "Планы", href: `/plans?supplier=${id}` });
  if (can.orders) items.push({ key: "orders", label: "Заказы", href: `/orders?supplier=${id}` });
  if (can.payments) items.push({ key: "payments", label: "Оплаты", href: `/finance/payments?view=list&supplier=${id}` });
  return items;
}
